import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomPaggerService } from '../../../../../../projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdModalContent } from '../../../../../../projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from '../../../../../../projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from '../../../../../../projects/Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { CurrentLanguage } from '../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { NgbdSortableHeader, SortEvent } from '../../../../../../projects/Autofacets-Core/src/app/directives/sortable.directive';
import { UserDataService } from '../../../../../../src/app/DataServices/user-data.service';
import * as fromEnums from '../../../../../../projects/Autofacets-Core/src/app/utils/enums';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { CategoryService } from '../../business-services/category.service';
import { AddPromotionsComponent } from '../promotions/add-promotions/add-promotions.component';
import { EditPromotionsComponent } from './edit-promotions/edit-promotions.component';
import { ActiveDealerDataMapper, GetAllActiveDealerResponseModel, Promotions } from '../../business-entities/promotions-model';
import { PromotionBusinessService } from '../../business-services/promotion.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { DealerHolidayBusinessService } from '../../business-services/dealer-holiday.service';
import { Categories } from '../../business-entities/category-list-model';
import { DealerRequestModel } from '../../business-entities/dealer-view-model';


@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.component.html'
 
})
export class PromotionsComponent implements OnInit, OnDestroy  {
  @ViewChild('content') content: ElementRef;
  language: string;
  total$: Observable<number>;
  popupCloseResult = false;
  SelectedVehical: any;
  confrimationTitle: string
  paginationSub: Subscription
  currentlagSub: Subscription
  currentDateTime: Promise<Date>;
  dealerList: Array<SelectListItemViewModel>;
  categoryList: Array<Categories>;
  promotionList: Promotions[];
  userRoleRightsDetails: UserRoleMenu;
  getAllActiveDealerList: GetAllActiveDealerResponseModel[] = [];
  // vehicleTypes: VehicleType[] = [];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  confrimationMessage: any;
  dealerRequestModel:DealerRequestModel = {
    statusId: 0,
    keyLocation:false,
    onlinePayment:false,
    isAdvanceSearch:false,
    isAllDealer:true,
    startRecordNumber: 0,
    PageSize: 25,
    SortColumn: 'Name',
    sortDirection: 'DESC',
    searchTerm: '',
    isForList: true
  };
  allDealerList: any;
  constructor(
    private promotionService: PromotionBusinessService,
    private dealerHolidayBusinessService: DealerHolidayBusinessService,
    public dealerBusinessService: DealerBusinessService,
    private getAllCategories: CategoryService,
    public pService: CustomPaggerService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private router: Router,
    private cookieservice: CookieService,
    private currentLanguageService: CurrentLanguage,
    private cd: ChangeDetectorRef,
    private userService: UserDataService,
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['brand', 'promotionName', 'Active'];
    this.pService.searchTerm = '';

  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.currentlagSub.unsubscribe();
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }

  async getPromotionList() {
    this.spinner.show();
    let language = this.cookieservice.get('userSelectedLanguage')
    let requestObj =
    {
      LANGUAGECODE: language
    }
    await this.promotionService.getPromotionList(requestObj).then((response) => {
      this.pService.dataSource = response;
      this.paginationSub = this.pService.dealers$.subscribe(result => {
        this.promotionList = this.promotionMapping(result);
      });
    })
    this.spinner.hide();
  }

  private promotionMapping(manualList: any) {
    let supperArray = [];
    if (manualList && manualList.length > 0) {

      for (let index = 0; index < manualList.length; index++) {
        const element = manualList[index];

        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.brandId = element.brandId;
        single.categoryId = element.categoryId;
        single.promotionImage = element.promotionImage === null ? './../../../assets/images/no-img.png' : element.promotionImage;
        single.promotionName = element.promotionName;
        single.category = element.category;
        single.createdBy = element.createdBy;
        single.createdDate = element.createdDate;
        single.updatedBy = element.updatedBy;
        single.updatedDate = element.updatedDate;
        single.dealerId = element.dealerId;
        single.dealer = element.dealer;
        single.brand = element.brand;
        single.isActive = element.isActive;
        single.promotionDescription = element.promotionDescription;
        single.originalPrice = element.originalPrice;
        single.startDate = element.startDate;
        single.endDate = element.endDate;
        single.isMultipleAllowed = element.isMultipleAllowed;
        single.quantity = element.quantity;
        single.offerPrice = element.offerPrice === 0 ? '' : element.offerPrice;
        single.offerStartDate = element.offerStartDate;
        single.offerEndDate = element.offerEndDate;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  ngOnInit(): void {
    this.getUserDealers();
    this.getCategories();
    this.getAllDealerList(this.dealerRequestModel);
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.Promotions);
    this.pService.dataSource = [];
    this.cd.detectChanges();
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
      this.getPromotionList()
    });
    setInterval(() => {
      this.currentDateTime = Promise.resolve(new Date());
    }, 1000);
  }

  async getUserDealers(){
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      this.dealerHolidayBusinessService.dealerList = this.dealerList;
    })
  }
  async getCategories(){
    let language = this.cookieservice.get('userSelectedLanguage')
    let requestObj =
    {
      LANGUAGECODE: language
    }
    await this.getAllCategories.getCategoryList(requestObj).then((response) => {
      this.categoryList = this.mapCategory(response);
      this.getAllCategories.categoryList = this.categoryList;
    })
  }
  mapdealer(array: UserDealersModel[]){
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element=>{
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }
  mapCategory(array: Categories[]){
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element=>{
        let single = Object();
        single.id = element.id
        single.name = element.categoryName

        supperArray.push(single);
      })
    }
    return supperArray;
  }
  onEdit(id: number) {
    this.promotionService.PromotionId = id
    const modalref = this.modalService.open(EditPromotionsComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }
  onAdd() {
    const modalref = this.modalService.open(AddPromotionsComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  refresh() {
    this.getPromotionList();
  }

  onActiveOrInactive(id: any) {
    let modelHeadermsg = this.translate.instant("lblActivateDeactivate");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblActiveInactive"), this.translate.instant("lblPromotions"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    let requestObj =
    {
      PromotionId: id
    }
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.promotionService
          .activeInactivePromotion(requestObj)
          .then((res) => {
            if (res.responseCode == Constant.SuccessResponseCode) {
              let successmsg = this.translate.instant("lblPromotionStatusChanged");
              this.toastr.success(successmsg);
              this.getPromotionList();
            }
            this.spinner.hide();
          },
            (err) => {
              this.spinner.hide();
            });
      }
    });
  }

  deletePromotion(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblPromotions"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.promotionService.deletePromotion(id).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let deletedmsg = this.translate.instant("lblPromotionDeleted");
            this.toastr.success(deletedmsg)
            this.ngOnInit();
          }
        });
      }
    });
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  /**
* Method to generate auto row number based on per page size
* @param cIndex
*/
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }

    return rtPageNumber;
  }

  async getAllDealerList(dealerRequestModel: DealerRequestModel) {
    this.spinner.show();
    await this.dealerBusinessService.getDealerList(dealerRequestModel).then((response) => {
      this.allDealerList = this.activeDealerDataMapper(response);
      this.getAllActiveDealer();
    });
  }

  private activeDealerDataMapper(response){
    let supperArray = [];
    if (response && response.length > 0) {
      response.forEach(element=>{
        let single = new ActiveDealerDataMapper();
        single.dealerId = element.dealerId;
        single.dealerName = element.name;
        single.isDealerActive = element.isActive;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  async activeInactiveDealer(evt, dealerId, isActive, content) {
    evt.preventDefault();
    this.confrimationTitle = this.translate.instant("lblPromotions");
    if (evt.target.checked) {
      this.confrimationMessage = this.translate.instant("lblActiveDealerPromotionMessage");
    }
    else {
      this.confrimationMessage = this.translate.instant("lblInActiveDealerPromotionMessage");
    }
    if (await this.callConfirmation(content)) {
      this.spinner.show();
      this.promotionService
        .activeInactiveDealer(dealerId)
        .then(async (res) => {
          if (res) {
            let successmsg = this.translate.instant("lblSuccessMessageToaster");
            this.toastr.success(successmsg);
           await this.getAllActiveDealer();
          } else {
            let warningmsg = this.translate.instant("lblWarningMessageToaster");
            this.toastr.warning(warningmsg);  
          }
          this.spinner.hide();
        },
          (err) => {
            this.spinner.hide();
          });
    }
  }
  async callConfirmation(content) {
    return this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title", centered: true })
      .result.then(
        (result) => {
          return result
        },
        (reason) => {
          return false;
        }
      );
  }
  async getAllActiveDealer() {
    this.spinner.show();
    await this.promotionService.getAllActiveDealer()
     .then((res) => {
        if (res) {
          this.allDealerList.map(item => {
            let activeDealer =  res.find(d => d.dealerId == item.dealerId);
            if(activeDealer){
              item.isActiveDealerForPromotion = activeDealer.isActive;
              return item;
            }
          });
        }
        this.spinner.hide();
      },
        (error) => {
          this.spinner.hide();
        })
      }
}
